import { IInitialisable } from "../../interfaces/IInitialisable";
import { toggleClass } from "../../utils/dom/toggleClass";
export class Usp implements IInitialisable {
	private documentHelper = document;
	private toggleClassHelper = toggleClass;

	// Tested
	public Init() {
		const elements = this.documentHelper.querySelectorAll<HTMLElement>("[data-cmpt-toggle].js_cmpt");
		elements.forEach((x) => this.setupToggleListener(x));
	}

	// Tested
	private setupToggleListener(el: HTMLElement) {
		el.addEventListener("click", (evt) => this.handleClick(evt));
	}

	// Tested
	private handleClick(evt: Event) {
		const el = evt.currentTarget as HTMLElement;
		const activeClassName = el.getAttribute("data-cmpt-toggle") ?? "active";
		this.toggleClassHelper(el, activeClassName);
		this.toggleAriaLabel(el, activeClassName);
	}

	// Tested
	private toggleAriaLabel(el: HTMLElement, activeClassName: string) {
		if (el.classList.contains(activeClassName)) {
			el.setAttribute("aria-label", "Play banner animation");
		} else {
			el.setAttribute("aria-label", "Pause banner animation");
		}
	}
}
